let config = {
  env: process.env.NODE_ENV,
  host: process.env.VUE_APP_API_ROOT,
  appId: 'wx3107a79472bb2e83',
  imgCdnHost: 'https://imgcdn.kingsunedu.com/'
}

export default config
